<div class="timesheet-page">
    <div class="timesheet-page__header">
        <pace-timesheet-picker
            [summaries]="summaries()"
            [selectedTimesheetId]="selectedTimesheet()?.timesheetId"
            (selected)="onTimesheetSelected($event)"
        ></pace-timesheet-picker>

        @if (isReadonly()) {
            <p class="timesheet-page__notice" translate="TIMESHEET_SUBMITTED_MESSAGE"></p>
        }
    </div>

    <div class="timesheet-page__rows">
        <div class="timesheet-page__head d-none d-lg-grid">
            <span translate="TIMESHEET_TABLE_START_LABEL"></span>
            <span translate="TIMESHEET_TABLE_DURATION_LABEL"></span>
            <span translate="TIMESHEET_TABLE_ACTIVITY_LABEL"></span>
            <span translate="TIMESHEET_TABLE_NOTIFICATION_LABEL"></span>
            <span></span>
        </div>

        @for (row of rows(); track row.rowId) {
            @switch (row.kind) {
                @case ('sow') {
                    <pace-timesheet-marker-row
                        marker="sow"
                        [instant]="timesheetForm.startOfWork"
                        [minInstant]="row.minStart"
                        [maxInstant]="row.maxEnd"
                    ></pace-timesheet-marker-row>
                }
                @case ('eow') {
                    <pace-timesheet-marker-row
                        marker="eow"
                        [instant]="timesheetForm.endOfWork"
                        [minInstant]="row.minStart"
                        [canCollapseGap]="!isReadonly() && hasTrailingGap()"
                        (collapseGap)="onCollapseEndOfWorkGap()"
                    ></pace-timesheet-marker-row>
                }
                @case ('gap') {
                    <pace-timesheet-gap-row
                        [row]="row"
                        [readonly]="isReadonly()"
                        [canAddTravelBack]="canAddTravelBack(row)"
                        (addEntry)="onAddManualEntry(row)"
                        (addTravelBack)="onAddTravelBack(row)"
                    ></pace-timesheet-gap-row>
                }
                @case ('work') {
                    @if (entryField(row.entryId); as field) {
                        <pace-timesheet-work-row
                            [row]="row"
                            [entry]="field"
                            [workCodeDescription]="workCodeDescription(row.workCode)"
                            [notificationDescription]="notificationDescription(row)"
                            [confirmationLink]="confirmationLink(row)"
                            [minInstant]="row.minStart"
                            [maxInstant]="row.maxEnd"
                            [canEditTravelType]="canEditTravelType(row)"
                            [canEditMeansOfTransport]="canEditMeansOfTransport(row)"
                            [meansOfTransportText]="meansOfTransportText(row)"
                            [travelTypeOptions]="travelTypeOptions()"
                            [meansOfTransportOptions]="meansOfTransportOptions()"
                            [addressCity]="workRowAddressCity(row)"
                        ></pace-timesheet-work-row>
                    }
                }
                @case ('manual') {
                    @if (entryField(row.entryId); as field) {
                        <pace-timesheet-manual-row
                            [row]="row"
                            [entry]="field"
                            [taskTypeOptions]="taskTypeOptions()"
                            [displayAddress]="displayAddress()"
                            [minInstant]="row.minStart"
                            [maxInstant]="row.maxEnd"
                            [addressLabel]="manualRowAddressLabel(row)"
                            [editable]="!selectedTimesheet()?.isSubmitted"
                            (selectAddress)="onSelectAddress(row)"
                            (deleteEntry)="onDeleteEntry(row)"
                        ></pace-timesheet-manual-row>
                    }
                }
            }
        } @empty {
            <p translate="TIMESHEET_NO_ENTRIES_LABEL"></p>
        }
    </div>
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid d-flex flex-column">
        <ul class="navbar-nav flex-column mx-auto">
            @if (hasInProgressOrToBeSignedConfirmations()) {
                <li class="navbar-text" translate="TIMESHEET_IN_PROGRESS_BLOCKS_SUBMIT_MESSAGE"></li>
            }
            @if (!isReadonly() && !timesheetForm().valid()) {
                <li class="navbar-text" translate="TIMESHEET_INVALID_MESSAGE"></li>
            }
        </ul>
        <ul class="navbar-nav d-flex flex-row gap-3 ms-auto mb-3">
            <li class="nav-item">
                <button
                    class="btn btn-primary"
                    type="button"
                    [disabled]="!canSubmit() || isSubmitting()"
                    (click)="send()"
                    translate="TIMESHEET_SAVE_TIMESHEET_TITLE"
                ></button>
            </li>
        </ul>
    </div>
</nav>
